import React, { memo } from 'react';
import { ApiContext, StateContext } from '../utils/context.js';
import Tab from '../tab/tab.js';
import tablistPropsManager from './tablistPropsManager.js';
var TabList = /*#__PURE__*/memo(function TabList() {
  var _React$useContext = React.useContext(StateContext),
      openTabIDs = _React$useContext.openTabIDs,
      selectedTabID = _React$useContext.selectedTabID,
      api = React.useContext(ApiContext),
      tablistProps = tablistPropsManager({
    api: api
  });

  return /*#__PURE__*/React.createElement("ul", tablistProps, openTabIDs.map(function (id) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: id,
      id: id,
      selectedTabID: selectedTabID
    });
  }));
}, function () {
  return true;
});
export default TabList;